import { Helmet } from "react-helmet-async";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ContactHero from "./components/ContactHero";
import ContactForm from "./components/ContactForm";
import ContactInfo from "./components/ContactInfo";

export default function ContactPage() {
  return (
    <main>
      <Helmet>
        <title>Contact Us | Africa Investment Portal</title>
        <meta name="description" content="Get in touch with Africa Investment Portal. We help foreign and local investors navigate company registration, compliance, and investment opportunities across East Africa." />
        <meta name="keywords" content="contact Africa Investment Portal, investment support East Africa, company registration help, business compliance Africa, investor assistance Rwanda, AIP contact" />
        <link rel="canonical" href="https://africainvestmentportal.com/contact" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Contact Africa Investment Portal" />
        <meta property="og:description" content="Reach our team for support with company registration, investment facilitation, and business opportunities across East Africa." />
        <meta property="og:url" content="https://africainvestmentportal.com/contact" />
        <meta property="og:image" content="https://africainvestmentportal.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Africa Investment Portal" />
        <meta name="twitter:description" content="Reach our team for support with company registration, investment facilitation, and business opportunities across East Africa." />
      </Helmet>
      <Navbar />
      <ContactHero />

      <section className="w-full px-6 lg:px-12 py-16 lg:py-24 bg-[#f8f9fb]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 max-w-[1280px] mx-auto">
          <ContactForm />
          <ContactInfo />
        </div>
      </section>

      <section className="w-full px-6 lg:px-12 py-14 bg-[#0A1628]">
        <div className="max-w-[1280px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-xl font-bold text-white mb-1">Prefer a direct conversation?</h3>
            <p className="text-white/50 text-sm">Reach us instantly on WhatsApp — we respond fast.</p>
          </div>
          <a
            href="https://wa.me/250788377109"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center gap-2.5 bg-[#25D366] hover:bg-[#1ebe58] text-white text-sm font-bold px-7 py-3.5 rounded-full transition-all whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-fill text-lg" />
            </div>
            Chat on WhatsApp
          </a>
        </div>
      </section>

      <Footer />
    </main>
  );
}
